<div class="relative w-full h-full">
  <div style="font-family: 'Open Sans'; color: #515251">
    <ng-container [ngSwitch]="dialogData.mode">
      <p *ngSwitchCase="'Verify'" style="font-size: 22px; font-weight: 600; padding: 24px 15px 0px 15px">Verify My GM
        Rewards</p>
      <p *ngSwitchCase="'Register'" style="font-size: 22px; font-weight: 600; padding: 24px 15px 0px 15px">My GM Rewards
        Registration</p>
      <p *ngSwitchDefault style="font-size: 22px; font-weight: 600; padding: 24px 15px 0px 15px">My GM Rewards
      </p>
    </ng-container>
    <p *ngIf="dialogData.memberStatus === 'Inactive'"
      style="font-size: 18px; font-weight: 400; padding: 18px 15px 0px 15px">
      Member inactive; please have Member contact the Call Center at 844-764-2665
    </p>
    <p style="font-size: 18px; font-weight: 400; padding: 18px 15px 0px 15px">Customer information</p>
  </div>
  <form [formGroup]="customerInformationForm">
    <ng-container [ngSwitch]="dialogData.mode">
      <p *ngSwitchCase="'Verify'" class="flex flex-row"
        style="font-size: 18px; font-weight: 400; padding: 16px 15px 0px 15px;color: #282828;">
        <span>Name: </span>
        <span class="ml-1">{{dialogData.associate.firstName}} {{dialogData.associate.lastName}}</span>
      </p>
      <p *ngSwitchCase="'Register'" class="flex flex-col"
        style="font-size: 18px; font-weight: 400; padding: 16px 15px 0px 15px;color: #282828;">
        <span class="mb-2">
          First Name<span style="color: #CC0000;">*</span>
        </span>
        <input formControlName="firstName" required
          [ngStyle]="customerInformationForm.get('firstName')?.invalid ? {'border': '2px solid #CC0000', 'outline': 'none'} : {'border': '1px solid #E8E9EA'}"
          style="height: 49px; border-radius: 6px; padding: 15px;" />
      </p>
    </ng-container>
    <p class="flex flex-col" style="font-size: 18px; font-weight: 400; padding: 16px 15px 0px 15px;color: #282828;">
      <span class="mb-2">
        Email<span style="color: #CC0000;">*</span>
      </span>
      <input formControlName="email" required
        [ngStyle]="customerInformationForm.get('email')?.invalid ? {'border': '2px solid #CC0000', 'outline': 'none'} : {'border': '1px solid #E8E9EA'}"
        style="height: 49px; border-radius: 6px; padding: 15px;" />
    </p>
    <div class="flex flex-row absolute bottom-2 right-4" style="font-size: 16px; height: 42px;">
      <button class="flex justify-center items-center cursor-pointer" style="color: #0054a6; margin-right: 25px;"
        (click)="cancel()">Cancel</button>
      <button class='flex justify-center items-center cursor-pointer'
        [ngStyle]="customerInformationForm.invalid ? {'background': '#bdbdbd'} : {'background': '#0054a6'}"
        style="width: 106px; gap: 8px; border-radius: 4px !important;" [disabled]="customerInformationForm.invalid"
        (click)="verifyOrRegister()">
        <span style="flex-grow: 0; flex-shrink: 0; text-align: left; color: #fff;">
          {{dialogData.mode === 'Verify' ? 'Verify' : 'Register'}}
        </span>
      </button>
    </div>
  </form>
</div>